import CargoForm from '../../../components/Purchasing/Cargo/CargoForm'
import React from 'react'
import { Modal, Tabs } from 'antd'
import FooterButtons from '../../../elements/Buttons/FooterButtons'

const { TabPane } = Tabs

function CreateCargoModal (props) {
  const { visible, submitting, submit, formRef, onCancel, isNew } = props
  return (
    <Modal
      visible={visible}
      title={'Create Cargo'}
      onCancel={onCancel}
      destroyOnClose={true}
      footer={
        <FooterButtons
          submit={submit}
          submitting={submitting}
          title={'Create Cargo'}
          isNew={isNew}
        />
      }
      width={'75%'}>
      <CargoForm ref={formRef} {...props} />
    </Modal>
  )
}

export default CreateCargoModal
